import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { cloneDeep, first, isEmpty, last } from 'lodash';
import { TemplateType, TemplateTypeLabel } from 'src/app/shared/constants/constants';
import { getCustomerToken } from 'src/app/shared/utils';
import { CommonService as dataService} from 'src/app/services/common-services/common.service';
import { ShopCommonService } from 'src/app/services/shop-service/shop.service';
import { CartService } from '../../../services/cart.service';
import { MatDialog } from '@angular/material/dialog';
//import { GetQuoteFormComponent } from '../get-quote-form/get-quote-form.component';
//import { GetQuoteFormComponent } from '../get-quote-form/get-quote-form.component';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
export interface MenuItem {
  id: number;
  category_id: number;
  parent_id: number;
  name: string;
  slug: string;
  children?: MenuItem[];
}
@Component({
  selector: 'app-strategic-procurement',
  templateUrl: './strategic-procurement.component.html',
  styleUrls: ['./strategic-procurement.component.scss'],
})
export class StrategicProcurementComponent implements OnInit {
  indirectApi!: string;
  products: any[] = [];
  receivedData: any;
  rootCatId: any;
  firstLevelCat: any;
  thirdLevelCat: any;
  parentCat: any;
  baseUrl = environment.BASE_URL;
  shopBaseUrl = environment.SHOP_BASE_URL;
  cartItems: any;
  companyId = localStorage.getItem('customercompanyId');
  originalProductsList: any[] = [];
  parentCatName: any;
  slug!: string | null;
  cartMap: Map<number, any> = new Map();
  responseArray: any[] = [];

  addedCatNames: Set<any> = new Set();
  addedSubCatNames: Set<any> = new Set();
  addedRFQType = '';
  currentPage:number = 1;
  itemsPerPage=20;
  categoryId!:number;
  sidebarList:any [] = [];
  categories:any [] = [];
  activeCategoryId: number | string | null = null;
  collapsedState: Map<any, boolean> = new Map();
  activeListItem!: any;
  categoryName:string = ''
  parentCategoryName:string = '';
  parentCategoryId!:number;
  constructor(
    private commonServices: dataService,
    private customerService: ShopCommonService,
    public dialog: MatDialog,
    private cartService: CartService,
    private toastr: ToastrService,
    private route: Router,
    private rout: ActivatedRoute,
  ) {}
  ngOnInit() {
    this.rout.queryParams.subscribe((params) => {
      this.currentPage = 1;
      let catId = params['catId'];
      this.categoryId = catId;
      this.getProductList(catId, this.currentPage, this.itemsPerPage);
      //this.getProductList(catId, this.currentPage, this.itemsPerPage);
      //this.getAllCategories();
      this.cartService.getAllCategories();
      this.cartService.getAllProductIdCategoryId();
      if(this.categoryId){
        this.currentPage = 1;
        this.getCategoryName(this.categoryId);
        this.getAllCategories(this.categoryId);
        this.setActive(this.categoryId);
      }
    });
    this.customerService.currentData$.subscribe((data) => {
      this.receivedData = data;
    });
    this.chekCartData();
  }
  chekCartData() {
    let cartLocalData: any = localStorage.getItem('cartData');
    if (cartLocalData) {
      let dataItem = JSON.parse(cartLocalData);
      this.assignCartMap(dataItem);
      let responseArray = Object.values(dataItem);
      let responseObject = {
        response: responseArray,
      };
      this.cartService.cartUpdates.next(responseObject);
    }
  }
  assignCartMap(data: any) {
    let map: any = new Map(Object.entries(data));
    // Convert string keys to number keys
    let assignCartMap: any = new Map();
    map.forEach((value: any, key: string) => {
      assignCartMap.set(Number(key), value);
    });
    this.cartMap = assignCartMap;
  }
  onScrollPage(){
    this.currentPage++;
    if(this.products.length > 15){
      this.appendData();
    }
    
  }
  appendData(){
    if (this.categoryId) {
      this.indirectApi = `${this.shopBaseUrl}v1/products?category_id=${this.categoryId}&limit=${this.itemsPerPage}&page=${this.currentPage}`;
    } else {
      this.indirectApi = `${this.shopBaseUrl}v1/products?limit=${this.itemsPerPage}&page=${this.currentPage}`;
    }
    //this.indirectApi = `${this.shopBaseUrl}v1/products?limit=${this.itemsPerPage}&page=${this.currentPage}`;
    this.commonServices.getData(this.indirectApi).subscribe((data) => {
      this.products = [...this.products, ...data?.data];
    });
  }
  getProductList(categoryId: number, pageNumber: number, pageSize: number){
    if (categoryId) {
      this.indirectApi = `${this.shopBaseUrl}v1/products?category_id=${categoryId}&limit=${this.itemsPerPage}&page=${this.currentPage}`;
    } else {
      this.indirectApi = `${this.shopBaseUrl}v1/products?limit=${this.itemsPerPage}&page=${this.currentPage}`;
    }
    this.commonServices.getData(this.indirectApi).subscribe((data) => {
      this.products = data?.data;
      this.originalProductsList = data?.data;
    });
  }

  getCategorySubCategory(categoryIds: number[], fromChild: boolean) {
    categoryIds?.forEach((categoryId: number) => {
      this.cartService.categories?.forEach((data: any) => {
        if (data.category_id == categoryId) {
          if (!fromChild) {
            this.addedSubCatNames.add(data.name);
            // } else if (fromChild) {
            //   this.addedCatNames.add(data.name);
          }
          if (data?.parent_id && data?.parent_id != 1) {
            this.getCategorySubCategory([data.parent_id], true);
          }
          if (data.parent_id == 1) {
            this.addedRFQType = data.name;
            this.addedCatNames.add(data.name);
          }
        }
      });
    });
  }

  getSelectedItemHierarchy(itemName: string, joinWith: string = '|') {
    const categories = new Set([...this.addedCatNames, ...this.addedSubCatNames]);
    return [...categories].join(joinWith);
  }

  addToCart(product: any) {
    this.addedCatNames = new Set();
    this.addedSubCatNames = new Set();
    this.addedRFQType = '';
    let rfqType = '';
    if (this.cartService.productIdCategoryId.has(product.id)) {
      let categoryIds: any = this.cartService.productIdCategoryId.get(product.id);
      categoryIds = new Set(categoryIds);
      this.getCategorySubCategory(categoryIds, false);
    }
    if (this.addedRFQType == 'Capital Equipments') {
      rfqType = TemplateType.CapEx;
    } else if (this.addedRFQType == 'Indirect MRO') {
      rfqType = TemplateType.InDirectMRO;
    } else {
      rfqType = TemplateType.Others;
    }
    const cmsCatName = first(Array.from(this.addedCatNames));
    const cmsSubCatName = last(Array.from(this.addedSubCatNames));
    let payLoad = {
      productId: product.id,
      productName: product.name,
      quantity: 1,
      date: new Date().toISOString(),
      cmsCatName: cmsCatName,
      cmsSubCatName: cmsSubCatName,
      imageUrl: product.base_image.original_image_url,
      rfqTemplate: rfqType,
      tags: this.getSelectedItemHierarchy(product.name),
    };
    this.companyId = localStorage.getItem('customercompanyId');
    // let customerToken = localStorage.getItem('customerToken');
    let customerToken = getCustomerToken();
    if (!customerToken) {
      this.addtoStorageCart(product.id, payLoad);
    } else {
      Object.assign(payLoad, {
        companyId: this.companyId,
      });
      let apiUrl = `${this.baseUrl}rfq/cart/addCart`;
      this.commonServices.postDatawithoutHeaders(apiUrl, payLoad).subscribe((data) => {
        this.toastr.success('Product added to cart', '', {
          positionClass: 'toast-bottom-right',
        });
        this.cartService.getCartItems();
      });
    }
    // this.commonServices.getData(this.indirectApi).subscribe((data) => {
    //   this.products = data?.data;
    //   this.originalProductsList = data?.data;
    // });
  }

  addtoStorageCart(id: number, product: any): void {
    let cartLocalData: any = localStorage.getItem('cartData');
    if(cartLocalData){
      let dataItem = JSON.parse(cartLocalData);
      let cartValue = Object.values(dataItem);
      cartValue.forEach((product: any) => {
        if (this.cartMap.has(product.productId)) {
          let productItem = this.cartMap.get(product.productId);
          if(productItem.productId == id){
            productItem.quantity = productItem.quantity + 1;
          }
          
        } else {
          this.cartMap.set(product.productId, product);
        }
      });
    }
    if (this.cartMap.has(id) && !cartLocalData) {
      let cartItem = this.cartMap.get(id);
      cartItem.quantity = cartItem.quantity + 1;
    } else {
      this.cartMap.set(id, product);
    }
    const obj = Object.fromEntries(this.cartMap.entries());
    localStorage.setItem('cartData', JSON.stringify(obj));
    this.toastr.success('Product added to cart', '', {
      positionClass: 'toast-bottom-right',
    });
    this.responseArray = Object.values(obj);
    let responseObject = {
      response: this.responseArray,
    };
    this.cartService.cartUpdates.next(responseObject);
    this.cartMap.clear();
  }

  searchProducts(event: any) {
    if (!isEmpty(event) && !isEmpty(event.target.value)) {
      const cloneProducts = cloneDeep(this.originalProductsList);
      this.products = cloneProducts.filter((product: any) => {
        return product.name.toLowerCase().includes(event.target.value.toLowerCase());
      });
    } else {
      this.products = this.originalProductsList;
    }
  }
  redirectProductDetail(productId: number, catId?: number, catName?: any) {
    this.route.navigate([`/product/${productId}`]);
  }

  isCustomerLoggedIn(): boolean {
    let customerToken = getCustomerToken();
    //let customerToken = localStorage.getItem('customerToken');
    if (customerToken) {
      return true;
    }
    return false;
  }
  getCategoryName(catId:number){
    let apiUrl = `${this.shopBaseUrl}v1/categories/${catId}`;
    this.commonServices.getData(apiUrl).subscribe({
      next : (response:any) => {
        this.categoryName = response.data.name;
      }
    })
  }
  getParentCategoryName(categoryId: number | undefined) {
    if (categoryId && categoryId !== 1) {
      const category = this.categories.find(cat => cat.category_id === categoryId);
      this.parentCategoryName = category.name;
      this.parentCategoryId = categoryId;
      //return category ? category.name : 'Unknown Category'; 
    }
    if(categoryId === 1){
      this.parentCategoryId = categoryId;
    }
   // return 'No Category'; 
  }
  getAllCategories(selectedId:number): void {
    let apiUrl = `${this.shopBaseUrl}categories?page=1&limit=1000`;
    this.commonServices.getData(apiUrl).subscribe({
      next: (data: any) => {
        this.categories = data?.data;
        let catItem:any = this.categories.find((item) => item.category_id == selectedId);
        this.buildSidebarMenu(this.categories, catItem.parent_id);
        this.getParentCategoryName(catItem.parent_id);
      },
      error: (error: HttpErrorResponse) => {
       // console.log(error);
      },
    });
  }
  buildSidebarMenu(items: MenuItem[], parentId: number): MenuItem[] {
    this.sidebarList = items
      .filter((item) => item.parent_id === parentId)
      .map((item) => ({
        ...item,
        //isColapsed: true,
        children: this.buildSidebarMenu(items, item.category_id),
      }));    
    return this.sidebarList;
  }
  identify(index: number, item: any) {
    return item.id;
  }
  getCategoryProduct(categoryId: number, categoryName: string, slug?: string) {
    this.currentPage = 1;
    this.activeCategoryId = categoryId;
    this.route.navigate(['/products'], {
      queryParams: {
        catId: categoryId,
      },
    });
  }
  toggleCollapse(item: MenuItem): void {
    const isCollapsed = this.collapsedState.get(item.category_id) || false;
    this.collapsedState.set(item.category_id, !isCollapsed);
  }
  isCollapsed(item: MenuItem): boolean {
    return this.collapsedState.get(item.category_id) || false;
  }
  setActive(categoryId: any) {
    this.activeListItem = categoryId;
  }
}
